module.exports = __webpack_public_path__ + "static/media/nigata.09ab1458.jpg";